module.exports = __webpack_public_path__ + "img/92093.ac2eeeac.svg";